'use strict';

angular.module('licensure.portal')
    .controller(
        'PortalTimeoutNotifyController', function ($rootScope, Idle, $uibModal, Utils, localStorageService, $state, Enterprise, Session) {
            $rootScope.message = "You are about to be logged out for inactivity.  Interact with the webpage to stay logged in.";
            $rootScope.warningCountdown = 300;
            $rootScope.showCountdown = true;
            $rootScope.timeoutInfoLoaded = false;

            Enterprise.getlogoutSettings($rootScope.enterpriseID).then(function (enterprise) {
                if (enterprise != null) {
                    Idle.setTimeout(enterprise.public_length);
                    Idle.setIdle((enterprise.public_session_length - 10) - enterprise.public_length);
                    $rootScope.message = enterprise.public_warning_text;
                    $rootScope.warningCountdown = enterprise.public_length;
                    $rootScope.timeoutInfoLoaded = true;
                }
                if ($rootScope.authenticatedPage) {
                    Idle.watch();
                } else {
                    Idle.unwatch();
                }
            });

            function loadTimeoutInfo() {
                Enterprise.getlogoutSettings($rootScope.enterpriseID).then(function (enterprise) {
                    if (enterprise != null) {
                        Idle.setTimeout(enterprise.public_length);
                        Idle.setIdle((enterprise.public_session_length - 10) - enterprise.public_length);
                        $rootScope.message = enterprise.public_warning_text;
                        $rootScope.warningCountdown = enterprise.public_length;
                        $rootScope.timeoutInfoLoaded = true;
                    }
                    if ($rootScope.authenticatedPage) {
                        Idle.watch();
                    } else {
                        Idle.unwatch();
                    }
                });
            }

            function closeModals() {
                if ($rootScope.warning) {
                    $rootScope.warning.close();
                    $rootScope.warning = null;
                }

                if ($rootScope.timedout) {
                    $rootScope.timedout.close();
                    $rootScope.timedout = null;
                }
            }

            $rootScope.$on('IdleStart', function () {
                closeModals();
                $rootScope.warning = $uibModal.open({
                    templateUrl: paths.app + 'components/timeout-notify/timeout-notify.html',
                    controller: 'PublicTimeoutNotifyModalController',
                    windowClass: 'modal-warning',
                    backdrop: 'static', //This prevents the modal from closing when clicking outside  
                    keyboard: false, //This prevents the modal from closing when pressing ESC
                    resolve: {
                        logout: function () {
                            return function () {
                                Idle.unwatch();
                                closeModals();
                                Utils.DeleteSessionCookie(true);
                                Session.expireSession(true);
                                localStorageService.remove('portalAuthorizationData');
                                $rootScope.userAccount = null;
                                $state.go("portal.menus.login", { messages: ["You have successfully logged out"] });
                            }
                        },
                        stayLoggedIn: function () {
                            return function () {
                                Idle.watch();
                                Session.checkIn();
                                closeModals();
                            }
                        }
                    }
                });
            });

            $rootScope.$on('IdleTimeout', function () {
                Session.IsSessionAlive(true).then(function (session) {
                    closeModals();

                    // If session was NOT kept alive by another tab, logout
                    if (!session) {
                        Idle.unwatch();
                        Utils.DeleteSessionCookie(true);
                        Session.expireSession(true);
                        localStorageService.remove('portalAuthorizationData');
                        $rootScope.userAccount = null;
                        $state.go("portal.menus.login", { messages: ["You have successfully logged out"] });
                    } else {
                        Idle.watch();
                    }
                });
            });

            //Resetting idle time when state is changed
            $rootScope.$on('$stateChangeStart', function () {
                closeModals();

                if ($rootScope.timeoutInfoLoaded) {
                    if ($rootScope.authenticatedPage) {
                        Idle.watch();
                    } else {
                        Idle.unwatch();
                    }
                }
                else
                    loadTimeoutInfo();
            });
        })

    .config(function (IdleProvider, KeepaliveProvider) {
        IdleProvider.interrupt('');
        IdleProvider.idle(1200);
        IdleProvider.timeout(300);
        KeepaliveProvider.interval(60);
    })